import { axiosPrivate } from "./axios";

const getDoordashOnboardingStatus = async ({ storeId, token }) =>
  await axiosPrivate
    .get(`/doordash-v2-service/onboarding/fetch-onboarding-status/${storeId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(({ data }) => data.body);

export default getDoordashOnboardingStatus;
